import { SORT_OPTIONS } from "./consts";

export const initialFilters = () => ({
	orientation: undefined,
	color: undefined,
	colorType: undefined,
});

export const getNewList = () => ({
	items: [],
	page: 0,
	total: 0,
	assetsInProgress: false,
	hasMoreAssets: false,
	selected: undefined,
});

export default (): UnsplashRecord => ({
	__record: "UnsplashRecord",
	isSignedIn: false,
	searchPhrase: "",
	slug: undefined,
	list: getNewList(),
	orderBy: SORT_OPTIONS.topic[0],
	isFiltersPanelOpen: false,
	areFiltersSet: false,
	filters: initialFilters(),
	uploadInProgress: false,
	homePageItems: [],
});
